import { render } from "./ConversationComposer.vue?vue&type=template&id=7c517020&scoped=true"
import script from "./ConversationComposer.vue?vue&type=script&lang=js"
export * from "./ConversationComposer.vue?vue&type=script&lang=js"

import "./ConversationComposer.vue?vue&type=style&index=0&id=7c517020&scoped=true&lang=css"

import exportComponent from "D:\\Accen_GITS\\Gestion-conge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c517020"]])

export default __exports__